module.exports = __webpack_public_path__ + "static/media/closeIcon.52aaed2a.svg";